import { GenSnackBar } from '@pinnacleautomotive/clarity-components';
import { useTranslation } from 'react-i18next';
import { useErrorSnackBar, useSuccessSnackBar } from '../hooks/useSnackBars';

export default function SnackBars() {
  const { t } = useTranslation('approvals');
  const { closeSuccessSnackBar, showSuccessSnackBar } = useSuccessSnackBar();
  const { closeErrorSnackBar, showErrorSnackBar, errorMessage } =
    useErrorSnackBar();

  return (
    <>
      <GenSnackBar
        open={showSuccessSnackBar}
        title={t('successMessage')}
        onClose={closeSuccessSnackBar}
      />
      <GenSnackBar
        open={showErrorSnackBar}
        title={errorMessage ?? t('errorMessage')}
        type="error"
        onClose={closeErrorSnackBar}
      />
    </>
  );
}
